// extracted by css-extract-rspack-plugin
export default {"logo":"_bd97d8f5","logoSvg":"_41f02ed7"};